import React from 'react';
import PropTypes from 'prop-types';
import { Col, Form, Row } from 'react-bootstrap-5';

import ContactPeopleForm from './people/form';
import ContactCompanyForm from './companies/form';

const ContactTypes = {
  company: 'company',
  person: 'person'
};

export default class QuickNewContactForm extends React.Component {
  static propTypes = {
    additionalFields: PropTypes.node,
    availableDatabaseOptions: PropTypes.arrayOf(PropTypes.array),
    personOrCompany: PropTypes.oneOf(Object.keys(ContactTypes)),
    projectId: PropTypes.number,
    showContactTypeSelector: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
  }

  state = {
    contact: null,
    showTypeSelector: true,
    personOrCompany: this.props.personOrCompany || ContactTypes.person
  }

  isCompany = () => this.state.personOrCompany === ContactTypes.company;
  isPerson = () => this.state.personOrCompany === ContactTypes.person;

  toggleTypeSelector = (showTypeSelector) => {
    this.setState({ showTypeSelector });
  }

  renderForm() {
    const {
      additionalFields,
      availableDatabaseOptions,
      projectId,
      onCancel,
      onSave
    } = this.props;

    return (
      <React.Fragment>
        {this.isPerson() &&
          <ContactPeopleForm
            additionalFields={additionalFields}
            availableDatabaseOptions={availableDatabaseOptions}
            projectId={projectId}
            toggleTypeSelector={this.toggleTypeSelector}
            onCancel={onCancel}
            onSave={onSave}
          />
        }
        {this.isCompany() &&
          <ContactCompanyForm
            additionalFields={additionalFields}
            availableDatabaseOptions={availableDatabaseOptions}
            projectId={projectId}
            onCancel={onCancel}
            onSave={onSave}
          />
        }
      </React.Fragment>
    );
  }

  render() {
    if (!this.props.showContactTypeSelector)  return this.renderForm();

    return (
      <React.Fragment>
        {(this.state.showTypeSelector) &&
          <Row className="mb-2">
            <Col xs="auto">
              <Form.Check
                checked={this.isPerson()}
                id="person-select"
                label="New Person"
                name="person-select"
                type="radio"
                onChange={() => this.setState({ personOrCompany: ContactTypes.person })}
              />
            </Col>
            <Col xs="auto">
              <Form.Check
                checked={this.isCompany()}
                id="company-select"
                label="New Company"
                name="company-select"
                type="radio"
                onChange={() => this.setState({ personOrCompany: ContactTypes.company })}
              />
            </Col>
          </Row>
        }
        {this.renderForm()}
      </React.Fragment>
    );
  }
}
